/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.sv')
    .component('svform', {
      restrict: 'E',
      bindings: {
        sv: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcutils/sv/svform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          vm.zipsave = zipsave;
          
          vm.$onInit = function () {
            vm.lastsv = angular.copy(vm.sv);
          };
          
          function save() {
            if (!angular.equals(vm.sv, vm.lastsv)) {
              vm.lastsv = angular.copy(vm.sv);
              vm.parentsave({sv: vm.sv});
            }
          }
          
          function cancel() {
            vm.sv = angular.copy(vm.lastsv);
            vm.oncancel();
          }
          
          function zipsave (zip, city) {
            $log.debug('debug: svform zipsave called: ', zip, city);
            vm.sv.postcode = zip;
            vm.sv.city = city;
          }
          
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());